import { Loader2 } from "lucide-react";

export interface SpinnerProps {
  size?: "sm" | "md" | "lg";
  className?: string;
}

/**
 * Animated loading spinner using Lucide Loader2 icon.
 */
export function Spinner({ size = "md", className = "" }: SpinnerProps) {
  const sizeMap = { sm: 16, md: 24, lg: 32 };
  return (
    <span className={`spinner spinner--${size} ${className}`} aria-label="Loading">
      <Loader2 size={sizeMap[size]} />
    </span>
  );
}
